import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

export default function NotFound() {
  return (
    <>
      <Helmet>
        <title>{`Page Not Found — Salihi Group`}</title>
      </Helmet>
      <section data-testid="not-found-page" className="pt-40 pb-24 md:pt-48 md:pb-32 bg-white">
        <div className="max-w-2xl mx-auto px-6 text-center">
          <div className="flex items-center justify-center gap-3 mb-5">
            <span className="gold-hairline" />
            <span className="text-gold text-xs uppercase tracking-[0.28em] font-medium">404</span>
            <span className="gold-hairline" />
          </div>
          <h1 className="font-serif text-navy text-5xl md:text-7xl font-light">Page not found</h1>
          <p className="text-mutedink mt-6 text-lg font-light">The page you are looking for does not exist or has been moved.</p>
          <Link to="/" className="btn-gold mt-10 inline-flex">Return Home</Link>
        </div>
      </section>
    </>
  );
}
